import { getBasicUserInfo } from '../getBasicUserInfo';
import _noop from 'lodash/noop';

let getUserInfoPromise: Promise<unknown> | null = null;

export const getUserInfoOnce = () => {
  return (dispatch: any) => {
    if (!getUserInfoPromise) {
      getUserInfoPromise = dispatch(getBasicUserInfo({})).then(_noop, () => {
        getUserInfoPromise = null;
      });
    }

    return getUserInfoPromise;
  };
};
